export const GET_TICATALOGUES_SUCCESS   = "GET_TICATALOGUES_SUCCESS";
export const GET_CUSTOMERS_SUCCESS      = "GET_CUSTOMERS_SUCCESS";
export const GET_TICATALOGUE_SUCCESS    = "GET_TICATALOGUE_SUCCESS";
export const GET_LISTS_SUCCESS          = "GET_LISTS_SUCCESS";
export const GET_LINES_SUCCESS          = "GET_LINES_SUCCESS";
export const DELETE_TICATALOGUE_SUCCESS = "DELETE_TICATALOGUE_SUCCESS";
export const GET_REQUEST_ERROR          = "GET_REQUEST_ERROR";
export const GET_REQUEST_SUCCESS        = "GET_REQUEST_SUCCESS";